import * as React from 'react';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Rating,
  Typography,
} from '@mui/material';
import FormatQuoteRoundedIcon from '@mui/icons-material/FormatQuoteRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';

interface Review {
  name: string;
  location: string;
  rating: number;
  quote: string;
}

const REVIEWS: Review[] = [
  {
    name: 'Tope Daniel',
    location: 'Cambridge',
    rating: 5,
    quote:
      'Booking my barber has never been easier. I found a great shop near me in minutes and booked a slot the same day.',
  },
  {
    name: 'Tommy Sneed',
    location: 'London',
    rating: 5,
    quote:
      'As a customer, I love being able to see opening hours and available slots up front before I even walk in.',
  },
  {
    name: 'Richard',
    location: 'Coventry',
    rating: 4,
    quote:
      'Barbers Limited helped me discover a fantastic independent barber that I never would have found otherwise.',
  },
];

const MARKETING_HIGHLIGHTS = [
  {
    icon: <CalendarMonthRoundedIcon sx={{ fontSize: 30 }} />,
    title: 'Book in Seconds',
    description:
      'Skip the phone calls. See real-time availability and book your next appointment online, anytime.',
  },
  {
    icon: <StorefrontRoundedIcon sx={{ fontSize: 30 }} />,
    title: 'Discover Local Talent',
    description:
      'Explore barber shops and independent barbers near you, complete with photos, reviews, and opening hours.',
  },
  {
    icon: <TrendingUpRoundedIcon sx={{ fontSize: 30 }} />,
    title: 'Built for Barbers Too',
    description:
      'Barbers and shop owners get powerful tools to manage bookings, schedules, and their growing business.',
  },
];

export default function MarketingSection() {
  return (
    <Box sx={{ bgcolor: '#111217', py: 9 }}>
      <Container maxWidth="lg">
        {/* Marketing highlights */}
        <Grid container spacing={4} sx={{ mb: 9 }}>
          {MARKETING_HIGHLIGHTS.map((item) => (
            <Grid item xs={12} md={4} key={item.title}>
              <Box sx={{ textAlign: 'center', px: 2 }}>
                <Box
                  sx={{
                    width: 68,
                    height: 68,
                    borderRadius: '50%',
                    mx: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    background:
                      'linear-gradient(135deg, #dd8709 0%, #b86e08 100%)',
                    boxShadow: '0 8px 20px rgba(221,135,9,0.35)',
                  }}
                >
                  {item.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: 'GFS Didot',
                    fontWeight: 'bold',
                    mt: 2.5,
                    color: '#fff',
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ mt: 1, color: 'rgba(255,255,255,0.65)' }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Reviews */}
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'GFS Didot',
            fontWeight: 'bold',
            textAlign: 'center',
            mb: 4,
            color: '#fff',
          }}
        >
          What People Are Saying
        </Typography>
        <Grid container spacing={3}>
          {REVIEWS.map((review) => (
            <Grid item xs={12} md={4} key={review.name}>
              <Card
                elevation={0}
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  p: 1,
                  bgcolor: '#1b1c22',
                  border: '1px solid rgba(255,255,255,0.08)',
                }}
              >
                <CardContent>
                  <FormatQuoteRoundedIcon
                    sx={{ color: '#dd8709', fontSize: 32 }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 2,
                      minHeight: 96,
                      fontStyle: 'italic',
                      color: 'rgba(255,255,255,0.85)',
                    }}
                  >
                    “{review.quote}”
                  </Typography>
                  <Rating value={review.rating} readOnly size="small" />
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      mt: 2,
                    }}
                  >
                    <Avatar sx={{ bgcolor: '#dd8709' }}>
                      {review.name.charAt(0)}
                    </Avatar>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        sx={{ color: '#fff' }}
                      >
                        {review.name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: 'rgba(255,255,255,0.55)' }}
                      >
                        {review.location}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
